/**
 * Get selected node selector such that it has default focus when user
 * presses TAB to navigate into folder tree. If there is no selected
 * node, first tabbable node wil have focus with TAB key.
 */
export default function getSelectedNodeSelector() {
    let styles = require('../components/TreeNode.scss');
    let classNames = require('classnames/bind').bind(styles);
    let selector = classNames({ selected: true });

    return '.' + selector;
}
